import React, { useState, useRef, useEffect, useContext } from "react";
import { baseUrl } from '../../config.js'
import { Link, NavLink, Outlet, useLocation } from 'react-router-dom';

import './NavBarCuenta.css';

import useToken from "../../useToken.js";

// Iconos SVG personalizados
const IconChevron = () => (
    <svg className="flecha" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 4.5L6 7.5L9 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconReservaciones = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M16 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M8 2V6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconFinanzas = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2V22" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M17 5H9.5C8.57174 5 7.6815 5.36875 7.02513 6.02513C6.36875 6.6815 6 7.57174 6 8.5C6 9.42826 6.36875 10.3185 7.02513 10.9749C7.6815 11.6313 8.57174 12 9.5 12H14.5C15.4283 12 16.3185 12.3687 16.9749 13.0251C17.6313 13.6815 18 14.5717 18 15.5C18 16.4283 17.6313 17.3185 16.9749 17.9749C16.3185 18.6313 15.4283 19 14.5 19H6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconMetricas = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3 3V18C3 18.5304 3.21071 19.0391 3.58579 19.4142C3.96086 19.7893 4.46957 20 5 20H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M18 9L13 14L9 10L3 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
);

const IconRadar = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
        <circle cx="12" cy="12" r="6" stroke="currentColor" strokeWidth="2"/>
        <circle cx="12" cy="12" r="2" stroke="currentColor" strokeWidth="2"/>
        <path d="M12 2L12 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
    </svg>
);

const NavBar = ({})=>{

    const {token} = useToken();
    const location = useLocation();
    const [subMenu, setSubMenu] = useState({});
    
    useEffect(()=>{
        console.log(location.pathname)
        if(location.pathname == '/host' || location.pathname == '/host/' || location.pathname == '/host/dashboard' || location.pathname == '/host/dashboard/'){
            setSubMenu({...subMenu, reservaciones: true})
        }
        else if(location.pathname.split("/")[3] == "reservaciones"){
            setSubMenu({...subMenu, reservaciones: true})
        }
        else if(location.pathname.split("/")[3] == "finanzas"){
            setSubMenu({...subMenu, finanzas: true})
        }
    }, [location])

    return(
        <div className="dashCuenta">
            <nav className="sidebar-dashboard">
                <div className="sidebar-content">
                    <div className="sidebar-header">
                        <h2>Dashboard</h2>
                    </div>
                    <div className="sidebar-menu">
                        <button className={(location.pathname.split("/")[3] == "reservaciones" || !location.pathname.split("/")[3] ? 'active' : '')} onClick={()=>{
                            setSubMenu({...subMenu, reservaciones: !subMenu?.reservaciones})
                        }}>
                            <div className="iconoCuenta">
                                <IconReservaciones />
                            </div>
                            <div>Reservaciones</div>
                            <div className={subMenu?.reservaciones ? "flecha-container arriba" : "flecha-container abajo"}>
                                <IconChevron />
                            </div>
                        </button>
                        {subMenu?.reservaciones &&
                            <div className="sub">
                                <NavLink to='/host/dashboard/reservaciones/espacios' className={location.pathname == '/host' || location.pathname == '/host/' || location.pathname == '/host/dashboard' || location.pathname == '/host/dashboard/' ? 'active' : ''}>
                                    <div className="linea"></div>
                                    <div>Espacios</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/reservaciones/reservaciones'>
                                    <div className="linea"></div>
                                    <div>Reservaciones</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/reservaciones/almacenes'>
                                    <div className="linea"></div>
                                    <div>Almacenes</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/reservaciones/publicaciones'>
                                    <div className="linea"></div>
                                    <div>Publicaciones</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/reservaciones/ubicaciones'>
                                    <div className="linea"></div>
                                    <div>Ubicaciones</div>
                                </NavLink>
                            </div>
                        }
                        <button className={(location.pathname.split("/")[3] == "finanzas" ? 'active' : '')} onClick={()=>{
                            setSubMenu({...subMenu, finanzas: !subMenu?.finanzas})
                        }}>
                            <div className="iconoCuenta">
                                <IconFinanzas />
                            </div>
                            <div>Finanzas</div>
                            <div className={subMenu?.finanzas ? "flecha-container arriba" : "flecha-container abajo"}>
                                <IconChevron />
                            </div>
                        </button>
                        {subMenu?.finanzas &&
                            <div className="sub">
                                <NavLink to='/host/dashboard/finanzas/pagos'>
                                    <div className="linea"></div>
                                    <div>Pagos</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/finanzas/disputas'>
                                    <div className="linea"></div>
                                    <div>Disputas</div>
                                </NavLink>
                                <NavLink to='/host/dashboard/finanzas/transferencias'>
                                    <div className="linea"></div>
                                    <div>Transferencias</div>
                                </NavLink>
                            </div>
                        }
                        <NavLink to='/host/dashboard/metricas'>
                            <div className="iconoCuenta">
                                <IconMetricas />
                            </div>
                            <div>Metricas</div>
                        </NavLink>
                        <NavLink to='/host/dashboard/radar'>
                            <div className="iconoCuenta">
                                <IconRadar />
                            </div>
                            <div>Radar</div>
                        </NavLink>
                    </div>
                </div>
            </nav>
            <Outlet/>
        </div>
    )
}

export default NavBar;